import { defineInlineAdSlotSchema } from "scmp-app/components/schema-render/common/inline-ad-slot/schemas";
import { defineTrackViewedPercentageSchema } from "scmp-app/components/schema-render/common/track-viewed-percentage/schemas";

export const NumberOfMobileInlineAdTestPlanMoreReadableElements = 7;

export const MobileInlineAdTestPlanSlotAdTagMap = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
};

export const NumberOfMoreReadableElements = 5;

export const InlineAdSlotTagMap = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
};

export const DefaultCustomContents = [
  defineTrackViewedPercentageSchema({
    percentage: "0",
  }),
  defineTrackViewedPercentageSchema({
    percentage: "20",
  }),
  defineTrackViewedPercentageSchema({
    percentage: "50",
  }),
  defineTrackViewedPercentageSchema({
    percentage: "90",
  }),
  defineTrackViewedPercentageSchema({
    percentage: "100",
  }),
  defineInlineAdSlotSchema({ row: 1, tag: InlineAdSlotTagMap[0] }),
  defineInlineAdSlotSchema({ row: 3, tag: InlineAdSlotTagMap[1] }),
  defineInlineAdSlotSchema({
    row: NumberOfMoreReadableElements,
    tag: InlineAdSlotTagMap[2],
  }),
  defineInlineAdSlotSchema({ row: 8, tag: InlineAdSlotTagMap[3] }),
  defineInlineAdSlotSchema({ row: 11, tag: InlineAdSlotTagMap[4] }),
  { row: 12, type: "inline-plus-widget" },
  defineInlineAdSlotSchema({ row: 14, tag: InlineAdSlotTagMap[5] }),
  defineInlineAdSlotSchema({
    infiniteAdsAfterNumber: "3",
    row: 17,
    tag: InlineAdSlotTagMap[6],
  }),
  defineInlineAdSlotSchema({ row: -1, tag: InlineAdSlotTagMap[7] }),
];

export const PrintCustomContents = [
  defineTrackViewedPercentageSchema({
    percentage: "0",
  }),
  defineTrackViewedPercentageSchema({
    percentage: "20",
  }),
  defineTrackViewedPercentageSchema({
    percentage: "50",
  }),
  defineTrackViewedPercentageSchema({
    percentage: "100",
  }),
];
